export interface AppserverCredentials {
    forsyningNodeId: number;
    forsyningId: string;
    cryptId: string;
    ejendomNr?: number;
    aktivNr?: number;
    installationNr?: number;
}
